import { render, staticRenderFns } from "./CategoryOverviewPage.vue?vue&type=template&id=2e608796&scoped=true&"
import script from "./CategoryOverviewPage.vue?vue&type=script&lang=js&"
export * from "./CategoryOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOverviewPage.vue?vue&type=style&index=0&id=2e608796&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e608796",
  null
  
)

export default component.exports